
export const formatPhone = (phone: string): string => {
  if (!phone) return "";

  const cleaned = phone.replace(/[^\d+]/g, "");

  let digits = cleaned.startsWith("+") ? cleaned.slice(1) : cleaned;
  
  if (digits.startsWith("8")) {
    digits = "7" + digits.slice(1);
  }

  if (!digits.startsWith("7") && digits.length > 0) {
    digits = "7" + digits;
  }

  if (digits.length === 0) return "";
  if (digits.length === 1) return `+${digits}`;
  if (digits.length <= 4) return `+7 (${digits.slice(1)}`;
  if (digits.length <= 7) return `+7 (${digits.slice(1, 4)}) ${digits.slice(4)}`;
  if (digits.length <= 9) return `+7 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  
  return `+7 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
};

export const cleanPhone = (phone: string): string => {
  if (!phone) return "";

  let cleaned = phone.replace(/[^\d+]/g, "");

  if (!cleaned.startsWith("+")) {
    if (cleaned.startsWith("8")) {
      cleaned = "+7" + cleaned.slice(1);
    } else {
      cleaned = "+" + cleaned;
    }
  } else {
    if (cleaned.startsWith("+8")) {
      cleaned = "+7" + cleaned.slice(2);
    }
  }

  return cleaned;
};

export const phoneMaskFormat = (phone: string): string => {
  if (!phone) return "";
  
  const cleaned = cleanPhone(phone);
  const digits = cleaned.replace("+", "");
  
  if (digits.length < 11) return phone;
  
  return `+7 (${digits.slice(1, 4)}) ***-**-${digits.slice(9, 11)}`;
};

